var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle42F = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 80",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M9.5 7H44l.725 7.251A2.5 2.5 0 0 1 42.237 17H19.5a2.5 2.5 0 0 0-2.5 2.5v48.639a2.5 2.5 0 0 1-2.835 2.477L7 69.647V9.5A2.5 2.5 0 0 1 9.5 7Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M7 71V9.5A2.5 2.5 0 0 1 9.5 7H45"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M37.5 74a2.5 2.5 0 0 0 2.5-2.5v-49a2.5 2.5 0 0 0-2.5-2.5h-15a2.5 2.5 0 0 0-2.5 2.5v49a2.5 2.5 0 0 0 2.5 2.5h15Z"
})));
SvgRectangle42F.viewBox = '0 0 60 80';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle42F);
export default ForwardRef;